<template>
  <v-container fluid>
    <v-row v-if="listNotif.length == 0">
        <v-row>
          <v-col cols="12">
            <div class="d-flex flex-column justify-center align-center">
              <div>
                <v-img
                  max-height="240"
                  max-width="240"
                  src="@/assets/noReward.png"
                  >
                </v-img>
              </div>
              <div>
                <p class="text-h6 font-weight-bold">Riwayat Kosong</p>
              </div>
              <div>
                <p>When you get reward, they’ll show up here</p>
              </div>
              <div class="btn-reload" @click="loadHistoryPoint">
                <p class="text-h6 mt-2">Memuat Ulang</p>
              </div>
            </div>
          </v-col>
        </v-row>
    </v-row>
    <v-row v-else>
        <v-col cols="12">
            <div class="points d-flex justify-space-between mx-2">
                <div class="pointDtl">
                    <v-img
                        max-height="40"
                        max-width="40"
                        src="@/assets/icon-color-coin.svg"
                    ></v-img>
                    <div>
                        <p class="text-subtitle-1 ma-0">M - Point</p>
                        <p class="totalPoint ma-0 font-weight-bold">{{  this.pointMekappin }}</p>
                    </div>
                </div>
                <div class="my-auto">
                    <v-icon @click="sheet = !sheet">mdi-information-outline</v-icon>
                </div>
            </div>
        </v-col>
        <v-col cols="12">
          <div class="riwayatPoin">
            <p class="text-h6 font-weight-bold">Riwayat Point</p>
          </div>
          <div class="pl-3" v-for="notif in this.listNotif" :key="notif.internalId">
            <div class="d-flex justify-space-between mb-3">
              <div>
                <p @click="getToDtlRiwayat(notif.internalId)" class="font-weight-bold ma-0" style="cursor: pointer;">
                  {{notif.pointExchanged.includes('+') ? 'Mendapatkan M - Point' : 'Menggunakan M - Point' }}
                </p>
                <p class="font-weight-thin ma-0">{{ notif.pointExchangedDate }}</p>
              </div>
              <div>
                <p class="font-weight-medium minus" :class="{ plus : notif.pointExchanged.includes('+')}">{{ notif.pointExchanged }}</p>
              </div>
            </div>
            <v-divider class="mb-3"></v-divider>
          </div>
          <div class="text-center">
            <v-btn class="btn-load-more" v-if="btnLoadMore" @click="loadMoreHistory">
              Load More
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12">
          <v-bottom-sheet v-model="sheet" inset class="ma-0">
            <div class="bottomDialog">
              <v-img
                  max-height="40"
                  max-width="40"
                  class="mx-auto"
                  src="@/assets/icon-color-coin.svg"
              ></v-img>
              <div>
                <p class="text-center font-weight-bold text-subtitle-1 ma-0">M - Point</p>
                <p class="text-center ma-0 font-weight-bold" style="color: #FFA800;">{{ this.pointMekappin }}</p>
              </div>
              <p class="text-center">Ini adalah jumlah M - point kamu saat ini. Dapatkan lebih banyak poin dengan belanja di M - Point</p>
            </div>
          </v-bottom-sheet>
        </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog 
      v-model="dialogDtlReward"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="dialogDtlReward = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Detail Reward</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-row>
            <v-col cols="12">
              <div class="dialog-container d-flex align-center flex-column">
                <div class="d-flex flex-row">
                  <p v-if="dtlReward.status == $constant.REWARD_MIN" class="text-sm-body-2 text-lg-h6">Anda sudah menggunakan</p>
                  <p v-else class="text-sm-body-2 text-lg-h6">Selamat kamu Mendapatkan</p>
                  <p class="text-sm-body-2 text-lg-h6 totalPoint ml-1">{{ dtlReward.pointExchanged }}</p>
                  <v-img
                      class="ml-1 mt-1"
                      max-height="22"
                      max-width="22"
                      src="@/assets/icon-color-coin.svg"
                  ></v-img>
                  <p class="text-sm-body-2 text-lg-h6 ml-1">Poin</p>
                </div>
                <p class="text-sm-subtitle-1 text-lg-subtitle-1">
                  Teruskan belanja pada Aplikasi M - Point untuk mendapatkan Point sebanyak banyak nya
                </p>
              </div>
            </v-col>
            
          </v-row>
          <v-row>
            <v-col cols="12">
              <div v-if="Object.keys(dtlReward).length !== 0 && dtlReward.productRewardResponseList.length">
                <p class="d-flex justify-center totalPesanan ma-0 pa-0">List Produk yang kamu Redeem </p>
                <div v-for="item in dtlReward.productRewardResponseList" :key="item.internalId"
                class="d-flex justify-center">
                  <div class="card mb-3">
                    <v-img
                      :src="`data:image/png;base64,${item.iconSmall}`"
                      max-width="80"
                      max-height="80"
                      contain
                    ></v-img>
                    <div class="ml-8">
                      <p class="title-card-produk pa-0 ma-0">{{ item.productName }}</p>
                      <p class="desc-card-produk pa-0 ma-0">{{  item.shoppingDate }}</p>
                      <div class="d-flex flex-row justify-space-between mt-3">
                        <div>
                          <div class="d-flex flex-row">
                            <v-img
                                max-height="20"
                                max-width="20"
                                src="@/assets/icon-color-coin.svg"
                            ></v-img>
                            <span class="ml-1" style="color: #FFA800;">{{ item.pointProduct}} Poin</span>
                          </div>
                        </div>
                        <p class="text-right ma-0 pa-0">{{ item.quantity }} x</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import moment from 'moment';

export default {
  data(){
    return {
      pointMekappin: 0,
      sheet: false,
      listNotif:[],
      btnLoadMore: false,
      pageNumber: 2,
      dialogDtlReward: false,
      dtlReward: {},
    }
  },
  created() {
    this.changeTitleApp("Reward");
  },
  methods: {
    ...mapActions([
      "getProfile",
      "getHistoryPoint",
      "changeTitleApp",
      "getRiwayatPoint"
    ]),

    getToDtlRiwayat(internalId){
      this.getRiwayatPoint({
        internalId: internalId
      })
      .then((response) => {
        this.dialogDtlReward = true;
        this.dtlReward = response.data.data;
      })
    },

    async loadMoreHistory(){
      await this.getHistoryPoint({
        pageNumber: this.pageNumber,
        pageSize: 10
      })
      .then((response) => {
        console.log(response);
        this.listNotif.push.apply(this.listNotif, response.data.data.listData);

        if(this.listNotif.length < response.data.data.totalData){
          this.btnLoadMore = true;
          this.pageNumber = this.pageNumber + 1;
        }else{
          this.btnLoadMore = false;
        }
      })
    },

    loadPoint(){
      this.getProfile().then((resp) => {
        this.pointMekappin = resp.data.data.poin;
      });
    },

    async loadHistoryPoint(){
      await this.getHistoryPoint({
        pageNumber: 1,
        pageSize: 10
      })
      .then((response) => {
        console.log(response);
        this.listNotif = response.data.data.listData;

        this.btnLoadMore = this.listNotif.length < response.data.data.totalData;
      })
    },

    formatDate(val){
      return moment(String(val)).format('DD MMM YYYY, hh:mm');
    }
  },
  mounted(){
    this.loadPoint();
    this.loadHistoryPoint();
  },
  computed:{
    
  }
}
</script>

<style scoped src="./Reward.scss" lang="scss"/>